import clsx from 'clsx';
import { forwardRef } from 'react';
import { TextField } from './TextField';

type MaskedTextFieldProps = {
  value: string;
  onChange: (value: string) => void;
  mask: string;
  disabled?: boolean;
  autoFocus?: boolean;
};

export const MaskedTextField = forwardRef<HTMLInputElement, MaskedTextFieldProps>(
  ({ value, onChange, mask, disabled = false, autoFocus = false }, ref) => {
    const maskLength = mask.length;
    const displayValue = value.split('').slice(0, maskLength);
    const remainingSlots = maskLength - displayValue.length;
    const maskDisplay = mask.slice(0, remainingSlots);

    return (
      <div className="relative w-full text-center tracking-[0.5em]">
        <TextField
          ref={ref}
          type="text"
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoFocus={autoFocus}
          maxLength={maskLength}
          inputMode="numeric"
          className={clsx(
            '[&_input]:text-transparent',
            displayValue.length > 0 ? '[&_input]:caret-transparent' : '[&_input]:caret-black'
          )}
        />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none px-4 py-3">
          <span className="text-black text-sm font-medium">{displayValue.join('')}</span>
          <span className="text-[#B2B2B2] text-sm font-medium">{maskDisplay}</span>
        </div>
      </div>
    );
  }
);

MaskedTextField.displayName = 'MaskedTextField';
